// extracted by mini-css-extract-plugin
module.exports = {"modal":"ImportMessage_modal__3tJJa","buttons":"ImportMessage_buttons__3lYHS"};